import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Add the and configure Auth0 library for future login
    and logout api functions.
  </p>
    </div>
    <p>{`We will be using Auth0 Hooks for this section and we are working off a `}<a parentName="p" {...{
        "href": "https://auth0.com/blog/ultimate-guide-nextjs-authentication-auth0/"
      }}>{`guide that Auth0`}</a>{` created about integrating Next.js with Auth0. The first step is to add the `}<inlineCode parentName="p">{`@auth0/nextjs-auth0`}</inlineCode>{` package:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save @auth0/nextjs-auth0
`}</code></pre>
    <p>{`Next, we need to create private variables that we will load into the Next.js server. Add the entire `}<inlineCode parentName="p">{`serverRuntimeConfig`}</inlineCode>{` block to the `}<inlineCode parentName="p">{`next.config.js`}</inlineCode>{` file:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-next.config.js"
      }}>{`require('dotenv').config();
const {
  BRANCH,
  GRAPHCMSURL,
  GRAPHCMSPROJECTID,
  domain,
  clientId,
  clientSecret,
  scope,
  redirectUri,
  postLogoutRedirectUri,
  cookieSecret,
} = process.env;

module.exports = {
  publicRuntimeConfig: {
    graphcms: {
      BRANCH,
      GRAPHCMSURL,
      GRAPHCMSPROJECTID,
    },
  },
  serverRuntimeConfig: {
    auth: {
      domain,
      clientId,
      clientSecret,
      scope,
      redirectUri,
      postLogoutRedirectUri,
    },
    cookieSecret,
  },
};

`}</code></pre>
    <p>{`These secrets will only be available via functions that we create in the `}<inlineCode parentName="p">{`pages/api`}</inlineCode>{` folder. A cool new veature in Next.js 9 is that any functions which are created in the api folder will be available as functions that your frontend can call against your actively running server. This means a function set as the export default in `}<inlineCode parentName="p">{`pages/api/me.js`}</inlineCode>{` will appear at `}<inlineCode parentName="p">{`www.mydomain.com/api/me`}</inlineCode>{` after we deploy our site. To make it even more convenient, if we deploy our app serverlessly, the me function will actually be converted to a lambda function and we can access it in the same way.`}</p>
    <p>{`Let's start by using the initAuth0 method to create an instance of the Auth0 plugin.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-utils/auth0.ts"
      }}>{`import { initAuth0 } from '@auth0/nextjs-auth0';
import getConfig from 'next/config';
const { serverRuntimeConfig } = getConfig();
const { auth, cookieSecret } = serverRuntimeConfig;

export default initAuth0({
  ...auth,
  session: {
    cookieSecret,
    cookieLifetime: 60 * 60 * 8,
    storeIdToken: false,
    storeAccessToken: false,
    storeRefreshToken: false,
  },
  oidcClient: {
    httpTimeout: 2500,
    clockTolerance: 10000,
  },
});

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      